import { Field } from '@chakra-ui/react';
import { useState } from 'react';

/**
 * Select Component
 * Wrapper around native HTML select with Chakra Field
 * Note: Chakra v3 Select is a complex compound component.
 * For simple dropdowns, native select is recommended.
 */
export function Select({
  label,
  error,
  helperText,
  isRequired,
  isDisabled,
  placeholder = 'Select option...',
  options = [],
  children,
  onFocus,
  onBlur,
  ref,
  ...props
}) {
    const [isFocused, setIsFocused] = useState(false);

    return (
      <Field.Root invalid={ !!error } required={ isRequired } disabled={ isDisabled }>
        {label && <Field.Label>{ label }</Field.Label>}
        <select
          ref={ ref }
          disabled={ isDisabled }
          style={{
            width: '100%',
            height: '36px',
            padding: '0 2.5rem 0 0.75rem',
            borderRadius: '3px',
            border: '1px solid',
            borderColor: error ? '#DE350B' : (isFocused ? '#4C9AFF' : '#DFE1E6'),
            backgroundColor: isFocused ? '#FFFFFF' : '#FAFBFC',
            color: '#172B4D',
            fontSize: '14px',
            lineHeight: '1.5',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            outline: 'none',
            transition: 'border-color 0.1s, background-color 0.1s',
            appearance: 'none',
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M4 6L8 10L12 6" stroke="%235E6C84" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/%3E%3C/svg%3E")',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 0.5rem center',
            backgroundSize: '16px',
          }}
          onFocusCapture={(e) => {
            setIsFocused(true);
            if (onFocus) onFocus(e);
          }}
          onBlurCapture={(e) => {
            setIsFocused(false);
            if (onBlur) onBlur(e);
          }}
          { ...props }
        >
          {placeholder && <option value="">{ placeholder }</option>}
          {children ||
            options.map((option) => (
              <option key={ option.value } value={ option.value } disabled={ option.disabled }>
                { option.label }
              </option>
            ))}
        </select>
        {error && <Field.ErrorText>{ error }</Field.ErrorText>}
        {helperText && !error && <Field.HelperText>{ helperText }</Field.HelperText>}
      </Field.Root>
    )
}

export default Select
